  <teleport v-if="vm" to="body">
    <div
      class="modal fade"
      id="addItemModal"
      tabindex="-1"
      aria-hidden="true"
      ref="addItemModal"
      @hidden.bs.modal="resetProductForm"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable modal-fullscreen-sm-down">
        <div class="modal-content rounded shadow-lg">

          <div class="modal-header border-0 shadow-sm">
            <h5 class="modal-title text-xs">
              Add {{ vm.modalType === 'product' ? 'Product' : 'Service' }}
            </h5>
            <button type="button" class="btn-close btn-close-black text-xs" data-bs-dismiss="modal" aria-label="Close"
              @click="vm.close_add_item_modal"></button>
          </div>

          <form @submit.prevent="vm.create_product(false)">
            <div class="modal-body modal-body-scroll px-4 pt-3 pb-4">
              <div v-if="vm.modalType === 'service'" class="mb-4">
              <label class="form-label fw-bold small">Service type <span class="text-danger">*</span></label>
              <div
                class="d-flex align-items-center gap-1 bg-light border p-1 w-100 rounded"
                :class="{ 'border-danger': vm.errors.service_type }"
              >
                <template v-for="type in vm.service_types" :key="type.id">
                  <input
                    type="radio"
                    class="btn-check"
                    name="serviceType"
                    :id="'type_' + type.id"
                    :value="type.id"
                    v-model="vm.item_form.service_type_id"
                  >
                  <label
                    class="btn btn-sm border-0 px-4 py-2 text-nowrap flex-fill rounded"
                    :class="vm.item_form.service_type_id === type.id ? 'btn-light bg-white text-dark shadow-sm border' : 'btn-light bg-transparent text-muted'"
                    :for="'type_' + type.id"
                  >
                    <span class="d-flex flex-column align-items-center lh-sm">
                      <span class="text-xxs fw-bold">{{ type.name === 'drop_in' ? 'Drop-In' : 'Field service' }}</span>
                      <span class="text-xxs fw-500 opacity-75">
                        {{ type.name === 'drop_in' ? 'Client comes to you' : 'You go to the client' }}
                      </span>
                    </span>
                  </label>
                </template>
              </div>

              <div v-if="vm.errors.service_type" class="text-danger small mt-2 d-flex align-items-center gap-1">
                <i class="bi bi-exclamation-circle-fill"></i>
                {{ vm.errors.service_type }}
              </div>
            </div>
              <!-- Name -->
              <div class="mb-3">
                <label class="form-label fw-bold">Name
                  <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control rounded border-light-subtle px-3 py-2 text-xxs"
                  v-model="vm.item_form.name" required>
              </div>

              <!-- Price -->
              <div class="mb-3">
                <label class="form-label fw-bold">Price <span class="text-danger">*</span></label>
                <input type="number" class="form-control rounded border-light-subtle px-3 py-2 text-xxs"
                  v-model="vm.item_form.price" min="0" step="0.01" required>
              </div>

              <div v-if="is_product_pricing_preview_visible(vm.item_form.price)" class="alert alert-warning py-2 px-3 text-xs mb-3 mb-md-4" role="alert">
                <div class="d-flex justify-content-between gap-3">
                  <span>Product price</span>
                  <strong>R{{ format_price(vm.item_form.price) }}</strong>
                </div>
                <div class="d-flex justify-content-between gap-3">
                  <span>Service fee</span>
                  <strong>R{{ format_price(calculate_product_fee(vm.item_form.price)) }}</strong>
                </div>
                <div class="d-flex justify-content-between gap-3 border-top mt-2 pt-2">
                  <span>Final price</span>
                  <strong>R{{ format_price(calculate_customer_product_price(vm.item_form.price)) }}</strong>
                </div>
              </div>
              <!-- Description -->
              <div class="mb-3">
                <label class="form-label fw-bold">Description</label>
                <textarea class="form-control rounded border-light-subtle px-3 py-2 text-xxs"
                  v-model="vm.item_form.description" rows="3" placeholder="Add a description..."></textarea>
              </div>
              <!-- Attributes (Sizes / Colours) -->
              <div class="mb-3" v-if="vm.modalType === 'product'">

                <label class="form-label fw-bold">Product Options</label>
                <div v-for="type in vm.attributeTypes" :key="type.id" class="mb-3">

                  <!-- Attribute Name -->
                  <div class="fw-bold mb-2">
                    {{ type.name }}
                  </div>

                  <!-- Input -->
                  <div class="d-flex mb-2">
                    <input
                      type="text"
                      class="form-control text-xs"
                      v-model="vm.new_attribute_value[type.name]"
                      :placeholder="'Add ' + type.name"
                      @keydown="vm.handle_attribute_input_keydown($event, type)"
                      @blur="vm.add_attribute_value(type)"
                    />
                    <button
                      type="button"
                      class="btn btn-sm btn-primary"
                      @click="vm.add_attribute_value(type)">
                      Add
                    </button>
                  </div>
                  <small class="text-muted d-block mb-2">Press Enter, type a comma, or click away to add options quickly.</small>

                  <!-- Pills -->
                  <div class="d-flex flex-wrap gap-2">
                    <span
                      v-for="(val, index) in vm.item_form.attributes[type.name]"
                      :key="index"
                      class="badge border rounded border-primary-subtle bg-primary-subtle text-primary d-inline-flex align-items-center gap-2 fw-semibold shadow-sm ps-3 pe-1 py-1"
                    >
                      {{ val }}
                         <button
                              type="button"
                              class="btn btn-primary rounded-circle border d-inline-flex align-items-center justify-content-center p-0 manage-product-option-remove"
                              @click="vm.remove_attribute(vm.item_form,type.name, index)"
                              aria-label="Remove option"
                            >
                              <i class="bi bi-x"></i>
                            </button>
                    </span>
                  </div>

                </div>
              </div>
               <div v-if="vm.modalType === 'service'" class="mb-3">
                <label class="form-label fw-bold">Service Location <span class="text-danger">*</span></label>
                <input type="text" ref="addItemLocationInput" class="form-control rounded border-light-subtle px-3 py-2 text-xxs"
  v-model="vm.item_form.service_location" placeholder="Enter your business address" autocomplete="off" @focus="initAddItemLocationAutocomplete" @input="vm.errors.service_location = null">
                <p v-if="vm.errors.service_location" class="text-danger text-xxs mt-1 mb-0">{{ vm.errors.service_location }}</p>
              </div>
              <!-- Category -->
              <label v-if="vm.catalogueTab !== 'services'"class="form-label fw-bold">Categories</label>

              <div v-if="vm.catalogueTab !== 'services'" class="mb-3">
                <select class="form-select rounded text-xs" v-model="vm.selected_category"
                  @change="vm.fetch_subcategories(vm.selected_category)">
                  <!-- Always shows this placeholder first -->
                  <option value="" disabled>Select Category</option>
                  <!-- Real vm.categories -->
                  <option v-for="cat in vm.categories" :key="cat.id" :value="cat.id">
                    {{ cat.name }}
                  </option>
                </select>
              </div>
              <!-- Subcategory -->
              <div v-if="vm.catalogueTab !== 'services'"class="mb-3">
                <select class="form-select rounded text-xs" v-model="vm.selected_subcategory">
                  <option value="" disabled>Select Subcategory</option>
                  <option v-for="sub in vm.subcategories" :key="sub.id" :value="sub.id">{{ sub.name }}</option>
                </select>
              </div>

              <!-- Images -->
              <div id="add-product-images-section" class="mb-3">
                <label class="form-label fw-bold">Images or videos</label>

                <div
                  class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center transition-all position-relative"
                  :class="vm.errors.product_images ? 'border-danger bg-danger-subtle' : (vm.isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed')"
                  @dragover.prevent="vm.isDragging = true" @dragenter.prevent="vm.isDragging = true"
                  @dragleave.prevent="vm.isDragging = false" @drop.prevent="vm.handle_drop" @click="clickFileInput">
                  <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                    <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                    <span class="fw-bold text-black text-sm">Drag & Drop images or videos here or click</span>
                  </div>

                  <input type="file" ref="fileInput" class="d-none" accept="image/*,video/*" multiple @change="vm.handleImagesUpload">
                </div>
                <div v-if="vm.errors.product_images" class="alert alert-warning py-2 px-3 text-xxs mb-0" role="alert">
                  {{ vm.errors.product_images }}
                </div>
              </div>

              <!-- Image Preview -->
              <div class="d-flex flex-wrap gap-2 mb-3">
                <div v-for="(file, index) in vm.previews" :key="index"
                  class="position-relative border rounded shadow-sm overflow-hidden w-24 h-24 flex flex-col items-center justify-center p-2">
                  <!-- IMAGE -->
                  <img v-if="file.type === 'image'" :src="file.src" class="preview-image rounded" />

                  <!-- VIDEO -->
                  <video v-else-if="file.type === 'video'" :src="file.src" class="preview-video rounded"
                    controls></video>

                  <!-- Remove button -->
                  <button type="button"
                    class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0 fs-6 px-2 py-0"
                    @click="vm.remove_file(index)">
                    &times;
                  </button>
                </div>
              </div>

            </div>
            <div v-if="vm.modalType === 'product' || vm.modalType === 'service'" class="modal-footer border-top bg-white shadow-sm px-4 py-3 d-flex gap-2">
              <button
                type="button"
                class="btn btn-sm text-xs btn-outline-primary rounded flex-fill"
                :disabled="vm.isLoading"
                @click="vm.create_product(false)"
              >
                <span v-if="vm.create_action_loading === 'draft'">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Saving...
                </span>
                <span v-else>
                  Save as Draft
                </span>
              </button>
              <button
                type="button"
                class="btn btn-sm text-xs btn-primary rounded flex-fill"
                :disabled="vm.isLoading"
                @click="vm.create_product(true)"
              >
                <span v-if="vm.create_action_loading === 'publish'">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Publishing...
                </span>
                <span v-else>
                  Publish
                </span>
              </button>
            </div>
            <div v-else class="modal-footer border-top bg-white shadow-sm px-4 py-3">
              <button type="submit" class="btn btn-sm text-xs btn-primary rounded" :disabled="vm.isLoading">
                <span v-if="vm.isLoading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Adding...
                </span>
                <span v-else>
                  Add Service
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>


  <teleport to="body">
    <!-- Product Manage Modal -->
    <div class="modal fade" id="manageProductModal" tabindex="-1" aria-hidden="true" ref="manageProductModal"
      @hidden.bs.modal="resetProductForm">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">

          <div class="modal-header border-0">
            <h5 class="modal-title text-xs">
              Edit {{ String(vm.modal_product?.product_type?.name || vm.modal_product?.product_type || '').toLowerCase() === 'service' ? 'Service' : 'Product' }}
            </h5>
            <button type="button" class="btn-close btn-close-black text-xs" data-bs-dismiss="modal" aria-label="Close"
              @click="vm.close_add_item_modal"></button>
          </div>

            <div class="ms-3">
              <p class="text-white-50 small mb-0">
                {{ vm.isEditing ? 'Update product details, options, media, and category settings.' : 'Review product details or switch to edit mode.' }}
              </p>
            </div>
          <div class="modal-body manage-product-modal-body">
            <div class="row g-4">
              <div class="col-12 col-lg-5">
                <div id="manage-product-images-section" class="border rounded p-3 bg-light-subtle h-100">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <label class="form-label fw-bold mb-0">Images</label>
                    <span class="badge bg-dark-subtle text-dark">{{ vm.previews.length || vm.modal_product?.images?.length || 0 }} media</span>
                  </div>

                  <div v-if="vm.isEditing"
                    class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center position-relative"
                    :class="vm.errors.product_images ? 'border-danger bg-danger-subtle' : (vm.isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed')"
                    @dragover.prevent="vm.isDragging = true" @dragenter.prevent="vm.isDragging = true"
                    @dragleave.prevent="vm.isDragging = false" @drop.prevent="vm.handle_drop"
                    @click="clickEditFileInput">
                    <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                      <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                      <span class="fw-bold text-secondary text-sm">Drag, drop, or click to add media</span>
                    </div>

                    <input type="file" ref="editFileInput" class="d-none" multiple accept="image/*,video/*" @change="vm.handleImagesUpload">
                  </div>
                  <div v-if="vm.isEditing && vm.errors.product_images" class="alert alert-warning py-2 px-3 text-xxs mb-3" role="alert">
                    {{ vm.errors.product_images }}
                  </div>

                  <div v-if="vm.previews.length" class="row g-2 py-2">
                    <div v-for="(file, index) in vm.previews" :key="index" class="col-6"
                      :class="{ 'd-none': file._delete }">
                      <div class="preview-image-wrapper position-relative border rounded overflow-hidden">
                        <img :src="file.src" class="preview-image">
                        <button type="button"
                          class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0 fs-6 px-2 py-0"
                          @click="vm.remove_file(index)">
                          &times;
                        </button>
                      </div>
                    </div>
                  </div>

                  <div v-if="!vm.previews.length && vm.modal_product?.images?.length" class="position-relative">
                    <div class="ratio ratio-1x1-product bg-light rounded overflow-hidden">
                      <img
                        :src="vm.modal_product.images[vm.active_modal_image_index || 0]?.image_url"
                        class="w-100 h-100 object-fit-cover"
                      />
                    </div>

                    <button
                      v-if="vm.modal_product.images.length > 1"
                      class="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-2 rounded-circle shadow-sm"
                      @click="vm.prev_modal_image"
                    >
                      <i class="bi bi-chevron-left"></i>
                    </button>

                    <button
                      v-if="vm.modal_product.images.length > 1"
                      class="btn btn-light position-absolute top-50 end-0 translate-middle-y me-2 rounded-circle shadow-sm"
                      @click="vm.next_modal_image"
                    >
                      <i class="bi bi-chevron-right"></i>
                    </button>

                    <div v-if="vm.modal_product?.images?.length" class="d-flex gap-2 mt-2 overflow-auto ad-image">
                      <img
                        v-for="(img, idx) in vm.modal_product.images"
                        :key="idx"
                        :src="img.image_url"
                        class="border rounded marketplace-card-image"
                        @click="vm.active_modal_image_index = idx"
                      />
                    </div>
                  </div>

                  <div v-if="!vm.previews.length && (!vm.modal_product?.images?.length) && !vm.isEditing"
                    class="preview-image-wrapper border rounded overflow-hidden d-flex align-items-center justify-content-center">
                    <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/image_placeholder.webp" class="preview-image">
                  </div>

                    <div v-if="vm.modal_product?.attributes && vm.modal_product?.attributes?.length && !vm.isEditing" class="mt-4">
                      <label class="form-label fw-bold">Product Options</label>
                      <div v-for="group in vm.group_attributes(vm.modal_product.attributes)"
                        :key="group.key"
                        class="attribute-row flex-wrap mb-3 d-block">
                        <div class="attribute-label mb-1 d-flex align-items-center gap-2">
                          <span class="attribute-label">
                            {{ group.label || group.key }}
                          </span>
                        </div>

                        <div class="d-flex flex-wrap gap-2 pointer">
                          <div
                            v-for="(attr, i) in group.values"
                            :key="i"
                            class="attribute-box d-flex align-items-center justify-content-center"
                          >
                            {{ attr.value }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="vm.isEditing && vm.catalogueTab !== 'services'" class="mt-4">
                      <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
                        <label class="form-label fw-bold mb-0">Product Options</label>
                        <small class="text-muted">Press Enter, type a comma, or click away to add options quickly.</small>
                      </div>

                      <div v-for="type in vm.attributeTypes" :key="type.id" class="border rounded-3 p-3 mb-3 bg-light-subtle">
                        <div class="fw-bold mb-2">
                          {{ type.name }}
                        </div>

                        <div class="d-flex mb-2">
                          <input
                            type="text"
                            class="form-control"
                            v-model="vm.new_attribute_value[type.name]"
                            :placeholder="'Add ' + type.name"
                            @keydown="vm.handle_attribute_input_keydown($event, type)"
                            @blur="vm.add_attribute_value(type)"
                          />
                          <button
                            type="button"
                            class="btn btn-primary"
                            @click="vm.add_attribute_value(type)">
                            Add
                          </button>
                        </div>

                        <div class="d-flex flex-wrap gap-2" v-if="vm.update_item_form.attributes[type.name?.toLowerCase()]?.length">
                          <span
                            v-for="(val, index) in vm.update_item_form.attributes[type.name?.toLowerCase()]"
                            :key="index"
                            class="badge rounded border border-primary-subtle bg-primary-subtle text-primary d-inline-flex align-items-center gap-2 fw-semibold shadow-sm ps-3 pe-1 py-1"
                          >
                            <span class="text-uppercase fw-bold">{{ formatAttributeOptionValue(val) }}</span>
                            <button
                              type="button"
                              class="btn btn-primary rounded-circle border d-inline-flex align-items-center justify-content-center p-0 manage-product-option-remove"
                              @click="vm.remove_attribute(vm.update_item_form,type.name?.toLowerCase(), index)"
                              aria-label="Remove option"
                            >
                              <i class="bi bi-x"></i>
                            </button>
                          </span>
                        </div>
                        <small v-else class="text-muted">No options added yet.</small>
                      </div>
                    </div>

                    <div v-if="(vm.isEditing || vm.modal_product?.category) && vm.catalogueTab !== 'services'" class="mt-4 mb-3">
                      <div v-if="!vm.isEditing">
                        <label class="form-label fw-bold">Category</label>
                        <span class="d-block">
                          {{ vm.modal_product?.category || 'None' }}
                        </span>
                      </div>

                      <div v-else>
                        <label class="form-label fw-bold">Category</label>
                        <select
                          class="form-select rounded"
                          v-model="vm.selected_category"
                          @change="vm.fetch_subcategories(vm.selected_category)"
                        >
                          <option value="" disabled>Select Category</option>
                          <option v-for="cat in vm.categories" :key="cat.id" :value="cat.id">
                            {{ cat.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div v-if="(vm.isEditing || vm.modal_product?.subcategory) && vm.catalogueTab !== 'services'" class="mb-3">
                      <div v-if="!vm.isEditing">
                        <label class="form-label fw-bold">Subcategory</label>
                        <span class="d-block">
                          {{ vm.modal_product?.subcategory || 'None' }}
                        </span>
                      </div>

                      <div v-else>
                        <label class="form-label fw-bold">Subcategory</label>
                        <select
                          class="form-select rounded"
                          v-model="vm.update_item_form.subcategory_id"
                          :disabled="!vm.subcategories.length"
                        >
                          <option value="" disabled>Select Subcategory</option>
                          <option v-for="sub in vm.subcategories" :key="sub.id" :value="sub.id">
                            {{ sub.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                </div>
              </div>

              <div class="col-12 col-lg-7">
                <div class="border rounded p-3 h-100">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                    <div>
                      <h6 class="fw-bold mb-1">
                    {{ vm.isEditing ? 'Edit' : '' }} {{ vm.catalogueTab === 'services' ? 'Service details' : 'Product details' }}
                  </h6>

                  <p class="text-muted small mb-0">
                    {{ vm.isEditing ? 'Update the ' + (vm.catalogueTab === 'services' ? 'service' : 'product') + ' fields below and save.' : 'Review the ' + (vm.catalogueTab === 'services' ? 'service' : 'product') + ' information below.' }}
                  </p>
                    </div>
                    <span class="badge" :class="vm.isEditing ? 'bg-primary-subtle text-primary' : 'bg-secondary-subtle text-secondary'">
                      {{ vm.isEditing ? 'Editing' : 'Viewing' }}
                    </span>
                  </div>

                  <div class="text-start">
                    <div class="mb-3">
                      <label class="form-label fw-bold">Name</label>
                      <span class="d-block" v-if="!vm.isEditing">{{ vm.modal_product?.name || 'Untitled product' }}</span>
                      <input v-else type="text" v-model="vm.update_item_form.name" class="form-control rounded">
                    </div>

                    <div class="mb-3">
                      <label class="form-label fw-bold">Price</label>
                      <span class="d-block" v-if="!vm.isEditing">R{{ vm.format_price(vm.display_price(vm.modal_product)) }}</span>
                      <input v-else type="number" v-model="vm.update_item_form.price" class="form-control rounded">
                      <div v-if="vm.isEditing && is_product_pricing_preview_visible(vm.update_item_form.price)" class="alert alert-warning py-2 px-3 text-xs mt-2 mb-0" role="alert">
                        <div class="d-flex justify-content-between gap-3">
                          <span>Product price</span>
                          <strong>R{{ format_price(vm.update_item_form.price) }}</strong>
                        </div>
                        <div class="d-flex justify-content-between gap-3">
                          <span>Service fee</span>
                          <strong>R{{ format_price(calculate_product_fee(vm.update_item_form.price)) }}</strong>
                        </div>
                        <div class="d-flex justify-content-between gap-3 border-top mt-2 pt-2">
                          <span>Final price</span>
                          <strong>R{{ format_price(calculate_customer_product_price(vm.update_item_form.price)) }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="mb-3" v-if="vm.modal_product?.description || vm.isEditing">
                      <label class="form-label fw-bold">Description</label>
                      <span class="d-block text-muted" v-if="!vm.isEditing">
                        {{ vm.modal_product?.description || 'No description added.' }}
                      </span>
                      <textarea
                        v-else
                        v-model="vm.update_item_form.description"
                        class="form-control rounded"
                        rows="4"
                        placeholder="Add a helpful description for this product"
                      ></textarea>
                    </div>

                    <div v-if="vm.catalogueTab === 'services'" class="mb-3 text-start">
                    <label class="form-label fw-bold">Service Type</label>
                    <span class="d-block" v-if="!vm.isEditing">
                      <i :class="vm.modal_product?.service_details?.type_name === 'drop_in' ? 'bi bi-geo-alt-fill text-primary' : 'bi bi-truck text-success'"></i>
                      {{ vm.modal_product?.service_details?.type_name === 'drop_in' ? 'Drop-In' : 'Field service' }}
                    </span>
                    <select v-else 
                      class="form-select rounded shadow-sm" 
                      v-model="vm.update_item_form.service_type_id">
                      <option value="" disabled>Select service type</option>
                      <option v-for="type in vm.service_types" :key="type.id" :value="type.id">
                        {{ type.name === 'drop_in' ? 'Drop-In' : 'Field service' }}
                      </option>
                    </select>
                  </div>

                  <div v-if="vm.catalogueTab === 'services'" class="mb-3 text-start">
                    <label class="form-label fw-bold">Service Location</label>
                    
                    <span class="d-block text-muted" v-if="!vm.isEditing">
                      <i class="bi bi-map me-1"></i>
                      {{ vm.modal_product?.service_details?.location || 'No location set' }}
                    </span>
                    <input 
                      v-else
                      ref="editItemLocationInput"
                      type="text" 
                      v-model="vm.update_item_form.location" 
                      class="form-control rounded shadow-sm" 
                      placeholder="Enter address or service area"
                      autocomplete="off"
                      @focus="initEditItemLocationAutocomplete"
                    >
                  </div>

                  </div>
                </div>
              </div>
          </div>
          </div>
          <!-- Footer Buttons -->
          <div class="modal-footer manage-product-modal-footer d-flex gap-2 border-top bg-white">
            <!-- Editing state: Cancel + Save -->
            <div v-if="vm.isEditing" class="d-flex gap-2 w-100">
              <button class="btn btn-outline-secondary rounded btn-sm flex-fill" @click="vm.cancel_edit()">
                Cancel
              </button>

              <button class="btn btn-primary btn-sm rounded flex-fill" @click="vm.update_product()" :disabled="vm.isLoading">
                <span v-if="vm.isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                <span>{{ vm.isLoading ? 'Saving...' : 'Save Changes' }}</span>
              </button>
            </div>

            <!-- Not editing state: Edit + Delete -->
            <div v-else class="d-flex gap-2 w-100">
              <button
                v-if="vm.catalogueTab !== 'services' && vm.open_product_advertisement"
                v-can-create="'advertisements'"
                class="btn btn-primary btn-sm rounded flex-fill d-none"
                @click="vm.open_product_advertisement(vm.modal_product)"
              >
                Advertise
              </button>

              <button
                v-if="vm.catalogueTab !== 'services' && vm.open_product_promo_code_manager"
                class="btn btn-primary btn-sm rounded flex-fill"
                @click="vm.open_product_promo_code_manager(vm.modal_product)"
              >
                Promo Codes
              </button>

              <button class="btn btn-primary btn-sm rounded flex-fill" @click="vm.edit_product(vm.modal_product)">
                Edit
              </button>

              <button class="btn btn-primary rounded btn-sm flex-fill" :disabled="vm.isDeleting"
                @click="vm.delete_product(vm.modal_product)">
                <span v-if="vm.isDeleting" class="spinner-border spinner-border-sm me-2" role="status"></span>
                <span v-if="!vm.isDeleting">Delete</span>
                <span v-else>Deleting...</span>
              </button>
            </div>
          </div>
      </div>
    </div>
    </div>
  </teleport>



